/**
 * Keys of known ribbon buttons (buttons included in roosterjs-react)
 */
export enum KnownRibbonButtonKey {
    /**
     * "Bold" button on the format ribbon
     */
    Bold,

    /**
     * "Italic" button on the format ribbon
     */
    Italic,

    /**
     * "Underline" button on the format ribbon
     */
    Underline,

    /**
     * "Font" button on the format ribbon
     */
    Font,

    /**
     * "FontSize" button on the format ribbon
     */
    FontSize,

    /**
     * "IncreaseFontSize" button on the format ribbon
     */
    IncreaseFontSize,

    /**
     * "DecreaseFontSize" button on the format ribbon
     */
    DecreaseFontSize,

    /**
     * "TextColor" button on the format ribbon
     */
    TextColor,

    /**
     * "BackgroundColor" button on the format ribbon
     */
    BackgroundColor,

    /**
     * "BulletedList" button on the format ribbon
     */
    BulletedList,

    /**
     * "NumberedList" button on the format ribbon
     */
    NumberedList,

    /**
     * "DecreaseIndent" button on the format ribbon
     */
    DecreaseIndent,

    /**
     * "IncreaseIndent" button on the format ribbon
     */
    IncreaseIndent,

    /**
     * "Quote" button on the format ribbon
     */
    Quote,

    /**
     * "AlignLeft" button on the format ribbon
     */
    AlignLeft,

    /**
     * "AlignCenter" button on the format ribbon
     */
    AlignCenter,

    /**
     * "AlignRight" button on the format ribbon
     */
    AlignRight,

    /**
     * "InsertLink" button on the format ribbon
     */
    InsertLink,

    /**
     * "RemoveLink" button on the format ribbon
     */
    RemoveLink,

    /**
     * "InsertTable" button on the format ribbon
     */
    InsertTable,

    /**
     * "InsertImage" button on the format ribbon
     */
    InsertImage,

    /**
     * "Superscript" button on the format ribbon
     */
    Superscript,

    /**
     * "Subscript" button on the format ribbon
     */
    Subscript,

    /**
     * "Strikethrough" button on the format ribbon
     */
    Strikethrough,

    /**
     * "Heading" button on the format ribbon
     */
    Heading,

    /**
     * "Code" button on the format ribbon
     */
    Code,

    /**
     * "Ltr" button on the format ribbon
     */
    Ltr,

    /**
     * "Rtl" button on the format ribbon
     */
    Rtl,

    /**
     * "Undo" button on the format ribbon
     */
    Undo,

    /**
     * "Redo" button on the format ribbon
     */
    Redo,

    /**
     * "ClearFormat" button on the format ribbon
     */
    ClearFormat,

    /**
     * @deprecated Use Heading instead
     * "Heading" button on the format ribbon
     */
    Header,
}
